import * as React from 'react';
import { SearchResults } from '../model/searchresultModel';
import { v4 as uuidv4 } from "uuid";

interface IngredientSearchResultsModel {
    result: SearchResults,
}

const IngredientSearchResults: React.FC<IngredientSearchResultsModel> = (props) => {
    return (
        <ul className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 gap-y-7 gap-x-5">
            {props.result.ingredientSearchResult.pages.map((ingredient) => {
                return (
                    <li key={uuidv4()}>
                        <div className="bg-green-50 h-full flex flex-col justify-start p-3 rounded-lg relative group focus-within:outline-[3px] focus-within:outline-red-secondary">
                            {ingredient.media !== null && (
                                <figure className="overflow-hidden rounded-xl mb-3 aspect-[3/2] bg-green-25 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWltYWdlLWljb24gbHVjaWRlLWltYWdlIj48cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiByeT0iMiIvPjxjaXJjbGUgY3g9IjkiIGN5PSI5IiByPSIyIi8+PHBhdGggZD0ibTIxIDE1LTMuMDg2LTMuMDg2YTIgMiAwIDAgMC0yLjgyOCAwTDYgMjEiLz48L3N2Zz4=')] bg-center bg-no-repeat">
                                    <picture>
                                        <source media="(min-width: 1280px)" srcSet={`${ingredient.media.url}__w=389_h=260__autocrop=true`} />
                                        <source media="(min-width: 1024px)" srcSet={`${ingredient.media.url}__w=304_h=203__autocrop=true`} />
                                        <source media="(min-width: 768px)" srcSet={`${ingredient.media.url}__w=346_h=242__autocrop=true`} />
                                        <img loading="lazy" src={`${ingredient.media.url}__w=735_h=502__autocrop=true`} alt={ingredient.media.description} className="transition-all group-hover:scale-110 group-active:scale-105 w-full"/>
                                    </picture>
                                </figure>
                            )}
                            {ingredient.media === null && (
                                <div className="rounded-xl mb-3 aspect-[3/2] bg-green-25 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWltYWdlLWljb24gbHVjaWRlLWltYWdlIj48cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiByeT0iMiIvPjxjaXJjbGUgY3g9IjkiIGN5PSI5IiByPSIyIi8+PHBhdGggZD0ibTIxIDE1LTMuMDg2LTMuMDg2YTIgMiAwIDAgMC0yLjgyOCAwTDYgMjEiLz48L3N2Zz4=')] bg-center bg-no-repeat"></div>
                            )}

                            <h3 className="font-semibold text-xl laptop:text-2xl">
                                {ingredient.pageTitle}
                            </h3>

                            <a href={ingredient.url} title={ingredient.pageTitle}
                               className="absolute inset-0 focus-visible:outline-[3px] focus-visible:outline-red-secondary rounded-lg">
                                <span className="sr-only">{ingredient.pageTitle}</span>
                            </a>
                        </div>
                    </li>
                )
            })}
        </ul>
    );
};

export default IngredientSearchResults;


